export const SET_LOADING = "SET_LOADING"
export const GET_CONSTANTS = "GET_CONSTANTS"
export const GET_CONSTANTS_REQUESTED = "GET_CONSTANTS_REQUESTED"
